// 投げ銭に関するstore
import axios from "axios";

import consts from '../../utils/consts'

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

const state = {
  items: [],
}


const getters = {
  skus: (state) => {
    return state.items
  },
}


const actions = {
  // 投げ銭のアイテムを取得
  async getDonationSkus ({ commit }, { api_path}) {
    await axios.get(api_path)
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        alert(res.data.message);
      } else {
        commit('setDonationSkus', res.data.data)
      }
    })
  }
}


const mutations = {
  // 投げ銭アイテムの設定
  setDonationSkus (state, skus) {
    state.items = skus
 },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
